import React from 'react'
import Layout from '../layouts'
import Hero from '../components/homesection/hero.js'
import AboutDan from '../components/homesection/aboutdan.js'
import Testimonial from '../components/homesection/testimonial.js'
import Gallery from '../components/homesection/gallery.js'
import './index.css'

import { graphql } from 'gatsby'
import qs from 'qs'

class IndexPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      menu: null,
      initialQueryParams: null,
      hasStateChanged: false,
      range: null,
    }
  }

  onSearchStateChange = searchState => {
    const updateAfter = 700
    const queryParams = qs.stringify([searchState.menu, searchState.range])

    clearTimeout(this.debouncedSetState)
    this.debouncedSetState = setTimeout(() => {
      this.setState({
        menu: searchState && searchState.menu,
        hasStateChanged: true,
        range: searchState && searchState.range,
        initialQueryParams: queryParams,
      })
      // navigate(`/?${queryParams}`, {})
    }, updateAfter)
  }

  render() {
    const { data } = this.props
    const location = this.state.initialQueryParams
    return (
      <Layout
        head={{ title: 'Home' }}
        location={location}
        history={this.props.history}
        onSearchStateChange={this.onSearchStateChange}
      >
        <main>
          <Hero location={location} />
          <AboutDan />
          <Testimonial />
          <Gallery />
        </main>
      </Layout>
    )
  }
}

export default IndexPage

export const Query = graphql`
  query {
    allSanityListing(limit: 4, sort: { fields: _createdAt, order: DESC }) {
      edges {
        node {
          id
          PropertyType
          UnparsedAddress
          ListPrice
          BedroomsTotal
          BathroomsTotalInteger
          LotSizeSquareFeet
          _createdAt
          Media {
            asset {
              url
            }
          }
        }
      }
    }
    allSanityTestimonial(limit: 5, sort: { fields: publishedAt, order: DESC }) {
      edges {
        node {
          id
          name
          rating
          description
          publishedAt
        }
      }
    }
    allSanityPost(limit: 3) {
      edges {
        node {
          id
          title
          slug {
            current
          }
          shortdesc
          body
          _createdAt
          mainImage {
            asset {
              url
            }
          }
          author {
            name
            image {
              asset {
                url
              }
            }
          }
        }
      }
    }
  }
`
